"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notSteppingHumidity = exports.notSteppingTemperature = exports.steppingHumidity = exports.steppingTemperature = void 0;
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
const values_1 = require("../values");
/**
 * The inlet-air sweeps only a steam express run offers. They live on the steam side rather than
 * with the air inputs because no other coil type steps the air state: the fluid coil steps its
 * own outlet temperature or flow, and express does not offer DX or condenser at all.
 */
exports.steppingTemperature = "stepproperty=1";
exports.steppingHumidity = "stepproperty=2";
/** When the single inlet value is still worth showing, because the run is not stepping it. */
exports.notSteppingTemperature = "stepproperty!=1";
exports.notSteppingHumidity = "stepproperty!=2";
function propertyDefinition(pvs) {
    const humidityConversion = {
        pressure: property_1.PropertyValueSet.getAmount("airinputspressure", pvs),
        temperature: property_1.PropertyValueSet.getAmount("airinputstemperature", pvs)
    };
    return [
        ...["min", "max", "step"].map((suffix, i) => ({
            sort_no: 11 + i,
            name: `airinputstemperature${suffix}`,
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(exports.steppingTemperature),
            value: []
        })),
        ...["min", "max", "step"].map((suffix, i) => ({
            sort_no: 21 + i,
            name: `airinputshumidity${suffix}`,
            group: "",
            quantity: "RelativeHumidity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: (0, values_1.filter)(exports.steppingHumidity),
            value: [],
            conversionParameters: humidityConversion
        }))
    ];
}
//# sourceMappingURL=air-sweeps-definition.js.map